<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Scorecard - NIF Excluído</strong>
          </div>
          <b-form-fieldset label="NIF">
            <b-form-input type="text" name="nif" v-model="item.nif" placeholder="NIF"  v-validate="'required'" :state="validateState('nif')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('nif') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-row>


            <b-form-group description="(AAAA-mm-dd)" label="Início" class="col-sm-4">
              <b-form-input type="text" v-model="item.date_start" v-mask="'####-##-##'" class="form-control"   v-validate="'required'" :state="validateState('date_start')" placeholder="Data de ínicio" ></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('date_start') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group description="(AAAA-mm-dd)" label="Fim" class="col-sm-4">
              <input type="text" v-model="item.date_end" v-mask="'####-##-##'" class="form-control" placeholder="Data de ínicio" />
            </b-form-group>

          </b-form-row>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'scIndependentOperators.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">

      </b-col>
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'SCOperator',
  props: ['id'],
  data() {
    return {
      item: {
        name: '',
        nif: '',
        date_start: '',
        date_end: null
      }
    }
  },
  methods: {
    addShipto() {
      this.item.nifs.data.push({})
    },
    removeShipto(i) {
      this.item.nifs.data.splice(i,1)
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('scorecard/excluded' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'scIndependentOperators.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('scorecard/excluded', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'scIndependentOperators.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('scorecard/excluded' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'scIndependentOperators.index'
          })
        })
    }
  }
}
</script>
